export default "__VITE_ASSET__CKHk8_p2__"